<template>
  <div class="kv-skeleton" :style="containerStyles">
    
    <template v-if="preset === 'message'">
      <div class="kv-bone header" style="width: 40%; height: 14px; margin-bottom: 6px;"></div>
      <div class="kv-bone" style="width: 90%; height: 10px; margin-bottom: 6px;"></div>
      <div class="kv-bone" style="width: 70%; height: 10px; margin-bottom: 6px;"></div>
      <div class="kv-bone" style="width: 40%; height: 10px; margin-bottom: 6px;"></div>
      <div class="kv-bone footer" style="width: 25%; height: 10px; margin-top: 2px; align-self: flex-end; opacity: 0.7;"></div>
    </template>

    <template v-else>
      <div 
        v-for="i in rows" 
        :key="i" 
        class="kv-bone"
        :style="getBoneStyle(i)"
      ></div>
    </template>

  </div>
</template>

<script>
export default {
  name: "KvSkeleton",
  props: {
    preset: { type: String, default: null },
    rows: { type: Number, default: 1 },
    width: { type: [String, Array], default: "100%" },
    height: { type: String, default: "10px" },
    bgBase: { type: String, default: null },
    bgHighlight: { type: String, default: null },
  },
  computed: {
    // Computada para controlar o estilo do container raiz
    containerStyles() {
      const styles = {};
      
      if (this.bgBase) styles['--sk-base'] = this.bgBase;
      if (this.bgHighlight) styles['--sk-highlight'] = this.bgHighlight;

      if (!Array.isArray(this.width)) {
        styles.width = this.width;
      } else {
        styles.width = '100%';
      }

      return styles;
    }
  },
  methods: {
    getBoneStyle(index) {
      let w;
      
      if (Array.isArray(this.width)) {
        w = (this.width[index - 1] || this.width[this.width.length - 1]);
      } else {
        w = '100%'; 
      }
      
      return {
        width: w,
        height: this.height,
        marginBottom: index < this.rows ? '8px' : '0'
      };
    }
  }
};
</script>

<style lang="less" scoped>
@keyframes kv-shimmer-anim {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.kv-skeleton {
  // REMOVIDO: width: 100%; (Isso causava o conflito com flex-1)
  // O width agora é controlado via inline style no template
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  
  --sk-base: #f0f2f5;
  --sk-highlight: #e6e8eb;

  .kv-bone {
    background: linear-gradient(90deg, var(--sk-base) 25%, var(--sk-highlight) 50%, var(--sk-base) 75%);
    background-size: 200% 100%;
    animation: kv-shimmer-anim 1.5s infinite;
    border-radius: 4px;
    
    &.footer {
      align-self: flex-end;
    }
  }
}
</style>